import styled from "styled-components"
import {Col} from "react-bootstrap"

import Card from "../../../Layout/Card"
import media from "../../../global/media"

const StyledCol = styled(Col)`
  ${media.phoneLandscape`
    padding-right: 0;
    padding-left: 0;
  `}
  ${Card} {
    ${media.phoneLandscape`
    border-radius: 0;
  `}
  }
`

export default StyledCol
